export function createOptimisticMutationCoordinator() {
  const latestMutations = new Map();

  return {
    begin(key) {
      const mutationId = Symbol(key);
      latestMutations.set(key, mutationId);
      return mutationId;
    },
    isCurrent(key, mutationId) {
      return latestMutations.get(key) === mutationId;
    },
    complete(key, mutationId) {
      if (latestMutations.get(key) === mutationId) {
        latestMutations.delete(key);
      }
    },
  };
}

export const optimisticMutationCoordinator = createOptimisticMutationCoordinator();

export function isSuccessfulMutationResponse(result) {
  return result?.response?.ok === true;
}
